import MainLayout from '@/components/layout/MainLayout';
import PersonalityAggregateChart from '@/components/dashboard/PersonalityAggregateChart';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CircleDecor } from '@/components/ui/visual-elements';
import { motion } from 'framer-motion';
import { fadeInVariants } from '@/lib/animations';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Shield } from 'lucide-react';

export default function Corporate() {
  return (
    <MainLayout>
      <div className="container mx-auto p-6 relative">
        <CircleDecor className="absolute top-10 right-10 opacity-10" variant="secondary" size="lg" />
        <CircleDecor className="absolute bottom-20 left-10 opacity-10" size="sm" />
        
        <h1 className="text-2xl font-bold mb-2">Soluções Vive Calme para Empresas</h1>
        <p className="text-sm text-gray-500 mb-8">Promova o bem-estar mental e a produtividade da sua equipe</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <motion.div
            variants={fadeInVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
            className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-brand-blue/10 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-users w-6 h-6 text-brand-blue"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4.5"></circle><path d="M20 8h-5"></path><path d="M18 15h-3"></path><path d="M16 11h-1"></path></svg>
              </div>
              <h3 className="text-xl font-bold">Análise de Personalidade</h3>
            </div>
            <p className="text-gray-600 mb-6 flex-grow">
              Entenda os traços de personalidade da sua equipe e impulsione o desenvolvimento individual e coletivo.
            </p>
            <Link to="/corporativo/personalidade">
              <Button className="w-full bg-brand-blue text-white hover:bg-opacity-90">
                Explorar Análise
              </Button>
            </Link>
          </motion.div>
          
          <motion.div
            variants={fadeInVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
            className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-brand-blue/10 rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-activity w-6 h-6 text-brand-blue"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
              </div>
              <h3 className="text-xl font-bold">Dashboard de Bem-Estar</h3>
            </div>
            <p className="text-gray-600 mb-6 flex-grow">
              Acompanhe as métricas de bem-estar da sua equipe e promova um ambiente de trabalho mais saudável e produtivo.
            </p>
            <Link to="/corporativo/dashboard">
              <Button className="w-full bg-brand-blue text-white hover:bg-opacity-90">
                Acessar Dashboard
              </Button>
            </Link>
          </motion.div>
          
          <motion.div
            variants={fadeInVariants}
            whileHover={{ y: -5, transition: { duration: 0.2 } }}
            className="bg-white rounded-xl shadow-md border border-gray-100 p-6 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Shield className="w-6 h-6 text-blue-700" />
              </div>
              <h3 className="text-xl font-bold">NR-1 Compliance</h3>
            </div>
            <p className="text-gray-600 mb-6 flex-grow">
              Garanta conformidade com a nova NR-1, incorporando riscos psicossociais ao seu PGR com nossa solução integrada.
            </p>
            <Link to="/corporativo/compliance">
              <Button className="w-full bg-blue-700 text-white hover:bg-blue-600">
                Acessar Compliance
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </MainLayout>
  );
}
